// src/components/Portfolio.js

import React from "react";
import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
} from "@mui/material";

const projects = [
  {
    title: "Menú digital para restaurantes",
    description:
      "Catálogo gastronómico interactivo con buscador, categorías y contacto directo por WhatsApp.",
    image: "/imagenes/projects/menus-demo.png",
    link: "https://menus.ultharkey.com/demo",
  },
  {
    title: "Tienda en línea",
    description:
      "Experiencia de comercio electrónico con productos, categorías, promociones y carrito de compra.",
    image: "/imagenes/projects/demo-web.png",
    link: "https://demo.ultharkey.com/",
  },
  {
    title: "Landing page con agenda",
    description:
      "Sitio profesional para presentar servicios y recibir solicitudes de cita de manera sencilla.",
    image: "/imagenes/projects/demo-landing.png",
    link: "https://demo-landing.ultharkey.com/",
  },
];

function Portfolio() {
  return (
    <Container
      id="portfolio"
      maxWidth="lg"
      sx={{
        py: { xs: 7, md: 12 },
        overflow: "hidden",
        backgroundColor: "#20242a",
        boxShadow: "0 0 0 100vmax #20242a",
        clipPath: "inset(0 -100vmax)",
      }}
    >
      <Typography
        variant="overline"
        component="p"
        align="center"
        sx={{ color: "secondary.main", letterSpacing: 3, mb: 1 }}
      >
        Trabajo reciente
      </Typography>
      <Typography
        variant="h3"
        component="h2"
        gutterBottom
        align="center"
        sx={{ fontSize: { xs: "2rem", md: "3rem" } }}
      >
        Portafolio
      </Typography>
      <Typography
        align="center"
        color="text.secondary"
        sx={{ maxWidth: 650, mx: "auto", mb: { xs: 4, md: 6 } }}
      >
        Soluciones reales para vender, presentar servicios y conectar con clientes.
      </Typography>
      <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
        {projects.map((project, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                borderRadius: 3,
                border: "1px solid rgba(255,255,255,.08)",
                boxShadow: "0 20px 50px rgba(0,0,0,.28)",
              }}>
              <CardMedia
                component="img"
                height="190"
                image={project.image}
                alt={project.title}
                sx={{ objectPosition: "top center" }}
              />
              <CardContent>
                <Typography variant="h6" component="h3" gutterBottom>
                  {project.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {project.description}
                </Typography>
              </CardContent>
              <Button
                component="a"
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                color="primary"
                sx={{ m: 2, mt: "auto" }}>
                Ver demo
              </Button>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Portfolio;
